import React from 'react';
import FocusTrap from './focusTrap';
import '../../style/modal.css';

interface ConfirmModalProps {
  open: boolean;
  title?: string;
  message?: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ open, title, message, confirmText = 'אשר', cancelText = 'בטל', loading, onConfirm, onCancel }) => {
  if (!open) return null;
  return (
    <div className="modal-overlay" role="dialog" aria-modal="true">
      <FocusTrap onEscape={onCancel}>
        <div className="modal-content modal-large">
          {title && <h3>{title}</h3>}
          <div>{message}</div>
          <div className="mt-12" style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button className="btn" onClick={onCancel} disabled={loading}>{cancelText}</button>
            <button className="btn btn-primary" onClick={onConfirm} disabled={loading}>{loading ? 'שולח...' : confirmText}</button>
          </div>
        </div>
      </FocusTrap>
    </div>
  );
};

export default ConfirmModal;
